module.exports = __webpack_public_path__ + "static/media/11_plantilla_menu_comida_11.16e52a11.png";